import {
    bundleIcon,
    BookSearch24Filled,
    BookSearch24Regular,
    MicRegular,
    MicFilled,
    Save28Regular,
    Save28Filled,
    ArrowRight24Filled,
    ArrowRight24Regular,
    Checkmark28Filled,
    Checkmark28Regular,
    Eye24Filled,
    Eye24Regular,
    Dismiss24Regular, 
    Dismiss24Filled,
    Copy24Filled,
    Copy24Regular,
    DocumentImage16Filled,
    DocumentImage16Regular  

} from "@fluentui/react-icons";


type IconTypeKey = "search" | "mic" | "arrow" | "check" | "preview" | "close";

const bundledIcon  = {
  "search": bundleIcon(BookSearch24Filled, BookSearch24Regular),
  "mic": bundleIcon(MicFilled, MicRegular),
  "save": bundleIcon(Save28Filled, Save28Regular),
  "arrow": bundleIcon(ArrowRight24Filled, ArrowRight24Regular),
  "check": bundleIcon(Checkmark28Filled, Checkmark28Regular),
  "preview": bundleIcon(Eye24Filled, Eye24Regular),
  "close" : bundleIcon(Dismiss24Filled, Dismiss24Regular),
  "copy": bundleIcon(Copy24Filled, Copy24Regular),
  "image" : bundleIcon(DocumentImage16Filled, DocumentImage16Regular),
}

export default (props: { type: IconTypeKey }) : JSX.Element => {
  const { type, ...otherProps } = props; 
  const Icon = bundledIcon[type];
  return (<Icon  {...otherProps}/>);

}

